import classes from './Menu.module.scss'
import { logout } from "../../../store/auth-slice";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory, useLocation } from "react-router-dom";
import { $t } from "../../../helpers/translator";
import { useEffect, useState } from "react";
import logo from '../../../assets/alma-logo-purple.svg'
import { IoChevronUp, IoChevronDown } from "react-icons/io5";
import { FaQuestionCircle, FaSignOutAlt, FaCog, FaLayerGroup } from 'react-icons/fa';
import { clearData } from "../../../store/data-slice";
import { setWhatsNewState } from "store/app-slice"
import HasPermission from 'helpers/permissions/HasPermission';

const Menu = (props) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();
    const [ currentExpanded, setCurrentExpanded ] = useState(null);
    const hasNewChanges = useSelector(state => state.auth.has_new_changes)

    const { items, userType } = props;

    useEffect(() => {
        let path = location.pathname;
        if (currentExpanded !== null) {
            const shouldBeActive = currentExpanded.children.filter(child => (child.pathIncludes && path.includes(child.pathIncludes)) || path === child.path).length > 0;
            if (!shouldBeActive) {
                setCurrentExpanded(null);
            }
        }
    }, [ location ])

    async function logoutClickHandler() {
        try {
            await dispatch(clearData());
            await dispatch(logout());
            history.push('/');
        } catch (e) {
            console.error('err logout ', e)
        }
    }

    function redirect(to) {
        history.push(to);
    }

    const toggleDropdown = (item) => {
        if (currentExpanded === item) {
            setCurrentExpanded(null)
        } else {
            setCurrentExpanded(item)
        }
    }

    const renderMenuItems = (menuItems) => {
        let path = location.pathname;

        const getMenuItemPermissions = (item) => {
            const modules = [];

            if (item.path) {
                if (item.path.split('/')[ 1 ].length >= 3) {
                    modules.push(item.path.split('/')[ 1 ]);
                }
            }
            if (item.pathIncludes) {
                if (!modules.includes(item.pathIncludes.split('/')[ 1 ])) {
                    modules.push(item.pathIncludes.split('/')[ 1 ]);
                }
            }

            return modules.map((m) => {
                return `${m}.view`
            });
        }

        return (
            <>
                { menuItems.filter(i => i !== false && i !== undefined).map((item, index) => {
                    const itemPermissions = getMenuItemPermissions(item);
                    const isDropdown = item.children && item.children.length > 0;
                    let isSelected = path === item.path || (item.pathIncludes && path.includes(item.pathIncludes));
                    let isDropDownActive = (isDropdown && currentExpanded && currentExpanded.name === item.name) || (isDropdown && item.children.filter(child => (child.pathIncludes && path.includes(child.pathIncludes)) || path === child.path).length > 0);

                    if (isDropDownActive) {
                        if (currentExpanded === null) {
                            isSelected = true;
                            isDropDownActive = false;
                        }
                    }


                    const handleOnClick = () => {
                        if (item.onClick) {
                            return item.onClick()
                        } else {
                            return !isDropdown ? redirect(item.path) : toggleDropdown(item)
                        }
                    }

                    return (
                        <HasPermission permission={ itemPermissions } match='any' key={ index }>
                            <div key={ index } onClick={ handleOnClick }
                                className={ `${classes[ 'link-container' ]} ${classes[ (isSelected ? 'link-container-selected' : '') ]}` }>
                                <div className={ classes[ 'link-content' ] }>
                                    <div className={ classes[ 'link-icon-img' ] }>
                                        { item.indicator === 'new' && <span className={ classes.indicator }></span> }
                                        { typeof item.icon == 'string' ?
                                            <img className={ classes[ 'img-icon' ] } src={ item.icon } alt={ item.name } /> :
                                            <span className={ classes[ 'icon' ] }>{ item.icon }</span> }</div>
                                    <div>{ item.name }</div>
                                </div>
                                {
                                    isDropdown &&
                                    <>
                                        { isDropDownActive ? <IoChevronUp /> : <IoChevronDown /> }
                                    </>
                                }
                            </div>
                            { isDropDownActive ?
                                <div style={ { marginLeft: '10px' } }>{ renderMenuItems(item.children) }</div> : null }
                        </HasPermission>
                    )
                }) }
            </>
        )
    }

    function renderMenu() {

        return (
            <div className={ classes[ 'container' ] }>
                <div className={ classes[ 'top-part' ] }>
                    <Link to="/">
                        <div className={ classes[ 'image-circle-container' ] }>
                            <img src={ logo } width={ '70%' } />
                        </div>
                    </Link>
                    { renderMenuItems(items) }
                </div>

                <div className={ classes[ 'bottom-part' ] }>
                    { renderMenuItems([
                        {
                            name: $t('global.menu.whatsnew'),
                            icon: <FaLayerGroup />,
                            indicator: hasNewChanges && 'new',
                            onClick: () => {
                                dispatch(setWhatsNewState(true));
                            }
                        },
                        { name: $t('global.menu.helpCenter'), icon: <FaQuestionCircle />, path: '/help', exact: true },
                        { name: $t('global.menu.logout'), icon: <FaSignOutAlt />, onClick: () => logoutClickHandler() }
                    ]) }
                </div>
            </div>
        )
    }

    return (
        <div className={ classes[ 'container' ] }>
            { renderMenu() }
        </div>
    )
};

export default Menu;
